module.exports = __webpack_public_path__ + "files/9f64f2455549ca2e22297b93273f0cef.png";